<!-- 铁运当日实际到达：轨道衡重车过衡与到货通知（计划）匹配 -->
<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
        <el-button v-if="showMatchButton(row)" type="text" size="small" @click="openMatch(row)">匹配</el-button>
      </template>
    </avue-crud>

    <dialog-reset
      height="65vh"
      top="5vh"
      width="80%"
      :title="detailDlg.title"
      :visible.sync="detailDlg.visible"
      custom-class="transport-record-detail-dialog"
      @changeVisible="onDetailVisibleChange"
    >
      <div v-loading="detailDlg.loading" class="detail-dialog-body">
        <div class="detail-summary" v-if="detailDlg.main && detailDlg.main.id">
          <span>入库状态：<b>{{ formatRailwayInboundStatus(detailDlg.main.railwayInboundStatus) }}</b></span>
          <span>翻车开始：<b>{{ detailDlg.main.tipplerStartTime || '—' }}</b></span>
          <span>翻车结束：<b>{{ detailDlg.main.tipplerEndTime || '—' }}</b></span>
          <span>可翻车时间：<b>{{ detailDlg.main.tipplerReadyTime || '—' }}</b></span>
          <span>设备状态：<b>{{ formatTipplerDeviceStatus(detailDlg.main.tipplerDeviceWorkStatus) }}</b></span>
          <span>最近PLC上报：<b>{{ detailDlg.main.tipplerLastPlcReportTime || '—' }}</b></span>
          <span>最近批次数：<b>{{ detailDlg.main.tipplerLastBatchCarriageCount != null ? detailDlg.main.tipplerLastBatchCarriageCount : '—' }}</b></span>
          <span>当前作业车号：<b>{{ detailDlg.main.tipplerCurrentCarriageNos || '—' }}</b></span>
          <span>重车时间：<b>{{ formatDisplayTime(detailDlg.main.trainArrivalTime) }}</b></span>
          <span>空车时间：<b>{{ formatDisplayTime(detailDlg.main.trainDepartTime) }}</b></span>
          <span>车厢数：<b>{{ detailDlg.main.carriageCount != null ? detailDlg.main.carriageCount : '—' }}</b></span>
          <span>总重(吨)：<b>{{ formatWeight(detailDlg.main.totalWeight) }}</b></span>
          <span>车次：<b>{{ detailDlg.main.trainNumber || '—' }}</b></span>
          <span>计划号：<b>{{ detailDlg.main.planNo || '—' }}</b></span>
        </div>
        <h4 class="detail-subtitle">车节明细</h4>
        <el-table :data="detailDlg.extList" border size="small" max-height="420" empty-text="暂无车节数据">
          <el-table-column label="序" width="56" align="center">
            <template slot-scope="{ row }">{{ extDisplaySeq(row) }}</template>
          </el-table-column>
          <el-table-column prop="carriageNumber" label="车号" min-width="100" show-overflow-tooltip />
          <el-table-column prop="carriageType" label="车型" width="88" show-overflow-tooltip />
          <el-table-column prop="grossWeight" label="毛重" width="80" align="right">
            <template slot-scope="{ row }">{{ formatWeight(row.grossWeight) }}</template>
          </el-table-column>
          <el-table-column prop="standardWeight" label="标重" width="80" align="right">
            <template slot-scope="{ row }">{{ formatWeight(row.standardWeight) }}</template>
          </el-table-column>
          <el-table-column prop="tareWeight" label="皮重" width="80" align="right">
            <template slot-scope="{ row }">{{ formatWeight(row.tareWeight) }}</template>
          </el-table-column>
          <el-table-column prop="totalWeight" label="净重" width="80" align="right">
            <template slot-scope="{ row }">{{ formatWeight(row.totalWeight) }}</template>
          </el-table-column>
          <el-table-column prop="cargoName" label="煤种" min-width="90" show-overflow-tooltip />
          <el-table-column label="翻车状态" width="96" align="center">
            <template slot-scope="{ row }">{{ formatTipplerStatus(row.tipplerStatus) }}</template>
          </el-table-column>
          <el-table-column prop="tipplerBatchNo" label="翻车批次" width="88" align="center" />
          <el-table-column prop="tipplerStartTime" label="翻车开始" min-width="156" show-overflow-tooltip />
          <el-table-column prop="tipplerEndTime" label="翻车结束" min-width="156" show-overflow-tooltip />
        </el-table>
      </div>
      <template slot="dialog_footer">
        <div class="dialog-footer-inner">
          <el-button size="small" type="primary" @click="detailDlg.visible = false">关闭</el-button>
        </div>
      </template>
    </dialog-reset>

    <dialog-reset
      height="75vh"
      top="4vh"
      width="88%"
      :title="dlg.modalTitle"
      :visible.sync="dlg.visible"
      custom-class="transport-record-match-dialog"
      @changeVisible="onMatchVisibleChange"
    >
      <div class="match-dialog-body">
        <div class="field-block">
          <label class="field-label">车皮到达预报</label>
          <el-select
            v-model="dlg.arrivalNoticeId"
            filterable
            clearable
            placeholder="请选择车皮到达预报"
            class="plan-select-full"
            size="small"
            @change="onNoticeChange"
          >
            <el-option
              v-for="n in dlg.noticeOptions"
              :key="n.id"
              :label="noticeLabel(n)"
              :value="n.id"
            />
          </el-select>
        </div>

        <div class="match-legend">
          <span><strong>规则</strong>：① 车号相同 → 匹配成功（绿）</span>
          <span>② 重车车号空 → 按<strong>同序号</strong>暂对计划，<strong>标红</strong>，补录后点「重新计算匹配」</span>
          <span>③ 有号但未对上 → <strong>车号未匹配</strong>（红）</span>
          <span>④ 重车多于计划 → <strong>多余重车</strong></span>
          <span>⑤ 计划多于重车 → <strong>无对应重车</strong></span>
          <span class="legend-actions">
            <el-button type="default" size="small" @click="recalcMatch">重新计算匹配</el-button>
            <el-button type="default" size="small" @click="syncMatchedNosFromWeigh">从重车带入计划车号（按匹配对）</el-button>
          </span>
        </div>

        <div class="dual-grid">
          <div class="dual-pane">
            <h4 class="pane-head">重车车节</h4>
            <div class="pane-scroll">
              <el-table
                :data="dlg.weighRows"
                border
                size="mini"
                :row-class-name="weighTableRowClassName"
                :empty-text="dlg.arrivalNoticeId ? '暂无重车车节' : '加载中…'"
              >
                <el-table-column label="序" width="52" align="center">
                  <template slot-scope="{ row }">{{ extDisplaySeq(row) }}</template>
                </el-table-column>
                <el-table-column label="车号" min-width="112">
                  <template slot-scope="{ row, $index }">
                    <el-input
                      v-model="row.carriageNumber"
                      size="mini"
                      :class="['cell-input', weighInputClass($index)]"
                      clearable
                      maxlength="8"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="carriageType" label="车型" width="88" show-overflow-tooltip />
                <el-table-column label="重车时间" width="156" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{ dlg.listRow && dlg.listRow.trainArrivalTime ? dlg.listRow.trainArrivalTime : '—' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="totalWeight" label="净重" width="76" align="right">
                  <template slot-scope="{ row }">{{ formatWeight(row.totalWeight) }}</template>
                </el-table-column>
                <el-table-column label="对应计划序" width="96" align="center">
                  <template slot-scope="{ $index }">{{ planSeqForWeigh($index) }}</template>
                </el-table-column>
                <el-table-column label="匹配方式" width="100" align="center">
                  <template slot-scope="{ $index }">
                    <span class="tag-mini">{{ weighMatchTag($index) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="dual-pane">
            <h4 class="pane-head">计划车节（可改车号、调整顺序）</h4>
            <div class="pane-scroll">
              <el-table
                v-if="dlg.arrivalNoticeId"
                :data="dlg.planRows"
                border
                size="mini"
                :row-class-name="planTableRowClassName"
                empty-text="该预报暂无车节明细"
              >
                <el-table-column label="序" width="48" align="center">
                  <template slot-scope="{ $index }">{{ $index + 1 }}</template>
                </el-table-column>
                <el-table-column label="车号" min-width="112">
                  <template slot-scope="{ row, $index }">
                    <el-input
                      v-model="row.carriageNo"
                      size="mini"
                      :class="['cell-input', planInputClass($index)]"
                      clearable
                      maxlength="8"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="cargoName" label="煤种" min-width="88" show-overflow-tooltip />
                <el-table-column label="对应重车序" width="96" align="center">
                  <template slot-scope="{ $index }">{{ weighSeqForPlan($index) }}</template>
                </el-table-column>
                <el-table-column label="匹配方式" width="100" align="center">
                  <template slot-scope="{ $index }">
                    <span class="tag-mini">{{ planMatchTag($index) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="148" align="center" class-name="row-actions">
                  <template slot-scope="{ $index }">
                    <el-button type="text" size="mini" :disabled="$index <= 0" @click="movePlanRow($index, -1)">上移</el-button>
                    <el-button
                      type="text"
                      size="mini"
                      :disabled="$index >= dlg.planRows.length - 1"
                      @click="movePlanRow($index, 1)"
                    >下移</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="pane-placeholder">请先选择车皮到达预报</div>
            </div>
          </div>
        </div>
        <p class="dlg-hint">
          两侧车号均可修改；调整计划车节顺序后请点「重新计算匹配」。保存后将写入车节并绑定本列车计划信息。
        </p>
      </div>
      <template slot="dialog_footer">
        <div class="dialog-footer-inner">
          <el-button size="small" @click="dlg.visible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="dlg.saving" :disabled="!dlg.arrivalNoticeId" @click="saveBind">保存</el-button>
        </div>
      </template>
    </dialog-reset>

  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { searchTimeConfig } from '@/basic-common/util/common'
import { getSettingDate } from '@/util/date'
import { getList, getDetail, bindArrivalNotice, exportExcel } from './api'
import { downloadXls } from '@/util/util'
import { getList as getArrivalNoticeList, getDetail as getArrivalNoticeDetail } from '@/views/railway-management/arrivalnote/api'

export default {
  name: 'TransportRecordWeighMatch',
  mixins: [crudMixins],
  data () {
    return {
      apiConfig: { getList },
      exportLoading: false,
      form: {},
      dlg: {
        visible: false,
        modalTitle: '计划与过衡匹配',
        listRow: null,
        transportRecordId: null,
        arrivalNoticeId: null,
        noticeOptions: [],
        weighRows: [],
        planRows: [],
        saving: false
      },
      detailDlg: {
        visible: false,
        loading: false,
        title: '运输到达',
        main: {},
        extList: []
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 140,
        column: [
          {
            label: '车次',
            prop: 'trainNumber',
            overHidden: true,
            minWidth: 100,
            maxlength: 30,
            showWordLimit: true
          },
          {
            label: '计划号',
            prop: 'planNo',
            overHidden: true,
            minWidth: 120
          },
          {
            label: '客户',
            prop: 'custName',
            overHidden: true,
            minWidth: 120
          },
          {
            label: '煤种',
            prop: 'cargoName',
            overHidden: true,
            minWidth: 100
          },
          {
            label: '重车时间',
            prop: 'trainArrivalTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            formatter: (row) => this.formatDisplayTime(row.trainArrivalTime),
            overHidden: true,
            minWidth: 168
          },
          {
            label: '空车时间',
            prop: 'trainDepartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            formatter: (row) => this.formatDisplayTime(row.trainDepartTime),
            overHidden: true,
            minWidth: 168
          },
          {
            label: '匹配状态',
            prop: 'status',
            width: 110,
            overHidden: true,
            formatter: (row) => {
              const m = { 0: '未匹配', 1: '匹配成功', 2: '到达通知' }
              const k = row.status
              if (k === null || k === undefined || k === '') return '未匹配'
              const n = Number(k)
              return m[n] != null ? m[n] : String(k)
            }
          },
          {
            label: '入库状态',
            prop: 'railwayInboundStatus',
            width: 116,
            overHidden: true,
            formatter: (row) => this.formatRailwayInboundStatus(row.railwayInboundStatus)
          },
          {
            label: '翻车开始',
            prop: 'tipplerStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            minWidth: 168
          },
          {
            label: '翻车结束',
            prop: 'tipplerEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            minWidth: 168
          },
          {
            label: '车厢数',
            prop: 'carriageCount',
            overHidden: true,
            width: 88,
            type: 'number'
          },
          {
            label: '总重(吨)',
            prop: 'totalWeight',
            overHidden: true,
            width: 100,
            type: 'number',
            precision: 2,
            formatter: (row) => this.formatWeight(row.totalWeight)
          },
          {
            ...searchTimeConfig,
            paramsKey: ['startTime', 'endTime'],
            searchValue: [getSettingDate('dayS'), getSettingDate('dayE')],
            dateDefault: false
          }
        ]
      }
    }
  },
  computed: {
    matchingState () {
      return this.computeMatching(this.dlg.weighRows || [], this.dlg.planRows || [])
    }
  },
  methods: {
    formatRailwayInboundStatus (value) {
      const map = {
        1: '重车到达',
        2: '计划匹配',
        3: '煤流线确认',
        4: '翻车机作业',
        5: '空车出厂',
        6: '入库完成确认'
      }
      if (value === null || value === undefined || value === '') return '-'
      const key = Number(value)
      return map[key] || String(value)
    },
    formatTipplerStatus (value) {
      const map = { 0: '待翻车', 1: '翻车中', 2: '已完成' }
      if (value === null || value === undefined || value === '') return '待翻车'
      const key = Number(value)
      return map[key] || String(value)
    },
    formatTipplerDeviceStatus (value) {
      const map = { 0: '空闲', 1: '作业中' }
      if (value === null || value === undefined || value === '') return '-'
      const key = Number(value)
      return map[key] || String(value)
    },
    /**
     * 列表「匹配」：status 为 0、1 或空时展示；2 不展示。
     */
    showMatchButton (row) {
      if (!row) return false
      const s = row.status
      if (s === 2 || s === '2') return false
      return true
    },
    /**
     * 打开运输到达详情弹窗（主表摘要 + 车节明细）。
     */
    async openDetail (row) {
      if (!row || !row.id) return
      this.detailDlg.visible = true
      this.detailDlg.loading = true
      this.detailDlg.title = this.buildDetailTitle(row)
      this.detailDlg.main = { ...row }
      this.detailDlg.extList = []
      try {
        const res = await getDetail(row.id)
        const dto = (res && res.data && res.data.data) || {}
        this.detailDlg.main = { ...row, ...dto }
        const list = dto.list || []
        this.detailDlg.extList = [...list].sort((a, b) => this.extSerialKey(a) - this.extSerialKey(b))
      } catch (e) {
        this.$message.error((e && e.message) || '加载详情失败')
      } finally {
        this.detailDlg.loading = false
      }
    },
    buildDetailTitle (row) {
      const t = this.formatDisplayTime(row && row.trainArrivalTime)
      const n = row && row.carriageCount != null ? row.carriageCount : '—'
      return `运输到达 — 重车 ${t} · ${n} 节`
    },
    onDetailClosed () {
      this.detailDlg.title = '运输到达'
      this.detailDlg.main = {}
      this.detailDlg.extList = []
    },
    /**
     * dialog-reset 显隐变化时清理状态（含关闭按钮、遮罩等路径）。
     */
    onDetailVisibleChange (visible) {
      if (!visible) this.onDetailClosed()
    },
    /**
     * 匹配弹窗关闭时重置表单状态。
     */
    onMatchVisibleChange (visible) {
      if (!visible) this.onDlgClosed()
    },
    /**
     * 与列表查询一致的时间范围（弹窗内加载到货通知下拉用）。
     */
    queryTimeBounds () {
      const merged = this.formatParams(Object.assign({}, this.defaultParams, this.query))
      if (merged.startTime && merged.endTime) {
        return { startTime: merged.startTime, endTime: merged.endTime }
      }
      return {
        startTime: getSettingDate('dayS'),
        endTime: getSettingDate('dayE')
      }
    },
    /**
     * 下拉筛选时间：后端按预报重车时间过滤，空值会被整段条件排除。
     * 以当前行过衡时间 ±7 天扩窗，减少「列表日与预报预计到达日」不一致导致无数据。
     */
    noticeTimeBoundsForDialog () {
      const row = this.dlg.listRow
      const t = row && row.trainArrivalTime
      if (!t || !String(t).trim()) {
        return this.queryTimeBounds()
      }
      const d = new Date(String(t).replace(/-/g, '/'))
      if (Number.isNaN(d.getTime())) {
        return this.queryTimeBounds()
      }
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      const fmt = (dt) =>
        `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`
      const start = new Date(d.getTime())
      start.setDate(start.getDate() - 7)
      start.setHours(0, 0, 0, 0)
      const end = new Date(d.getTime())
      end.setDate(end.getDate() + 7)
      end.setHours(23, 59, 59, 999)
      return { startTime: fmt(start), endTime: fmt(end) }
    },
    /** 解析分页接口返回的记录数组（兼容 records / list） */
    unwrapNoticePage (res) {
      const pack = (res && res.data && res.data.data) || {}
      return pack.records || pack.list || []
    },
    unwrapTransportRecordPage (res) {
      const pack = (res && res.data && res.data.data) || {}
      return pack.records || pack.list || []
    },
    isEmptyTime (value) {
      if (value === undefined || value === null) return true
      const text = String(value).trim()
      return text === '' || text === '-' || text === '—' || text === '鈥?' || text.indexOf('1970-01-01') === 0
    },
    formatDisplayTime (value) {
      return this.isEmptyTime(value) ? '—' : value
    },
    formatWeight (value) {
      if (value === undefined || value === null || value === '') return '—'
      const num = Number(value)
      return Number.isFinite(num) ? num.toFixed(2) : String(value)
    },
    isEmptyNo (s) {
      if (s === undefined || s === null) return true
      const t = String(s).trim()
      return t === '' || t === '—' || t === '-'
    },
    normalizeNo (s) {
      return this.isEmptyNo(s) ? '' : String(s).trim()
    },
    sameNo (a, b) {
      return this.normalizeNo(a) !== '' && this.normalizeNo(a) === this.normalizeNo(b)
    },
    /**
     * 与原型 HTML 一致：车号优先，重车车号为空时按同序号暂对计划。
     */
    computeMatching (actual, plan) {
      const n = actual.length
      const m = plan.length
      const usedA = new Array(n).fill(false)
      const usedP = new Array(m).fill(false)
      const a2p = new Array(n).fill(null)
      const p2a = new Array(m).fill(null)
      const aTag = new Array(n).fill(null)
      const pTag = new Array(m).fill(null)

      for (let i = 0; i < n; i++) {
        if (this.isEmptyNo(actual[i].carriageNumber)) continue
        for (let j = 0; j < m; j++) {
          if (usedP[j]) continue
          if (this.sameNo(actual[i].carriageNumber, plan[j].carriageNo)) {
            a2p[i] = j
            p2a[j] = i
            usedA[i] = usedP[j] = true
            aTag[i] = '车号'
            pTag[j] = '车号'
            break
          }
        }
      }

      for (let i = 0; i < n; i++) {
        if (usedA[i]) continue
        if (!this.isEmptyNo(actual[i].carriageNumber)) continue
        let j = -1
        if (i < m && !usedP[i]) j = i
        else {
          for (let k = 0; k < m; k++) {
            if (!usedP[k]) {
              j = k
              break
            }
          }
        }
        if (j < 0) {
          aTag[i] = '多余重车'
          continue
        }
        a2p[i] = j
        p2a[j] = i
        usedA[i] = usedP[j] = true
        aTag[i] = '序号'
        pTag[j] = '序号'
      }

      for (let i = 0; i < n; i++) {
        if (usedA[i]) continue
        if (!this.isEmptyNo(actual[i].carriageNumber)) aTag[i] = '车号未匹配'
      }

      for (let j = 0; j < m; j++) {
        if (!usedP[j]) pTag[j] = '无对应重车'
      }

      return { a2p, p2a, aTag, pTag }
    },
    extDisplaySeq (row) {
      if (row.carriageSerial != null) return row.carriageSerial
      if (row.carriageCount != null) return row.carriageCount
      return '—'
    },
    weighMatchTag (i) {
      const t = this.matchingState.aTag[i]
      if (!this.dlg.arrivalNoticeId || !(this.dlg.planRows || []).length) return '待选预报'
      return t || '—'
    },
    planMatchTag (j) {
      const t = this.matchingState.pTag[j]
      if (!this.dlg.arrivalNoticeId) return '—'
      return t || '—'
    },
    planSeqForWeigh (i) {
      const j = this.matchingState.a2p[i]
      if (this.matchingState.aTag[i] === '多余重车') return '—'
      if (j == null) return '—'
      return String(j + 1)
    },
    weighSeqForPlan (j) {
      const i = this.matchingState.p2a[j]
      if (i == null) return '—'
      return String(this.extDisplaySeq(this.dlg.weighRows[i]))
    },
    weighInputClass (i) {
      const t = this.matchingState.aTag[i]
      if (!this.dlg.arrivalNoticeId || !(this.dlg.planRows || []).length) return ''
      if (t === '序号' || t === '车号未匹配' || t === '多余重车' || this.isEmptyNo(this.dlg.weighRows[i] && this.dlg.weighRows[i].carriageNumber)) {
        return 'is-warn'
      }
      return ''
    },
    planInputClass (j) {
      if (this.isEmptyNo(this.dlg.planRows[j] && this.dlg.planRows[j].carriageNo)) return 'is-warn'
      const t = this.matchingState.pTag[j]
      if (t === '序号' || t === '无对应重车') return 'is-warn'
      return ''
    },
    weighTableRowClassName ({ rowIndex }) {
      const t = this.matchingState.aTag[rowIndex]
      if (t === '车号') return 'row-ok'
      if (t === '序号' || t === '车号未匹配' || t === '多余重车') return 'row-danger'
      return ''
    },
    planTableRowClassName ({ rowIndex }) {
      const t = this.matchingState.pTag[rowIndex]
      if (t === '车号') return 'row-ok'
      if (t === '序号' || t === '无对应重车') return 'row-danger'
      return ''
    },
    recalcMatch () {
      void this.matchingState
    },
    syncMatchedNosFromWeigh () {
      if (!this.dlg.planRows || !this.dlg.planRows.length) {
        this.$message.warning('请先选择车皮到达预报')
        return
      }
      const { p2a } = this.matchingState
      const actual = this.dlg.weighRows
      this.dlg.planRows.forEach((p, j) => {
        const ai = p2a[j]
        if (ai != null && actual[ai]) {
          const v = actual[ai].carriageNumber
          this.$set(p, 'carriageNo', v != null ? String(v).trim() : '')
        }
      })
      this.$message.success('已按当前匹配关系从重车带入计划车号')
    },
    movePlanRow (idx, delta) {
      const arr = this.dlg.planRows
      const j = idx + delta
      if (j < 0 || j >= arr.length) return
      const t = arr[idx]
      this.$set(arr, idx, arr[j])
      this.$set(arr, j, t)
    },
    noticeLabel (n) {
      const p = n.planNo || ''
      const c = n.custName || ''
      const tn = n.trainNumber || ''
      return [p, c, tn].filter(Boolean).join(' · ') || ('ID:' + n.id)
    },
    /**
     * 加载绑定下拉：优先带出已发送到达通知、待轨道衡匹配的计划，再合并未到达计划作为人工兜底。
     */
    async loadNoticeOptions () {
      const { startTime, endTime } = this.noticeTimeBoundsForDialog()
      const attempts = [
        { page: 1, size: 300, noticeSendStatus: 1, startTime, endTime },
        { page: 1, size: 300, noticeSendStatus: 1 },
        { page: 1, size: 300, arrivalStatus: 0, startTime, endTime },
        { page: 1, size: 300, arrivalStatus: 0 },
        { page: 1, size: 300, startTime, endTime },
        { page: 1, size: 300 }
      ]
      const records = []
      const exists = {}
      for (const params of attempts) {
        try {
          const res = await getArrivalNoticeList(params)
          const list = this.unwrapNoticePage(res)
          list.forEach((item) => {
            if (!item || item.id == null || exists[item.id]) return
            exists[item.id] = true
            records.push(item)
          })
        } catch (e) {
          // 当前轮查询失败时继续尝试更宽松的候选范围。
        }
      }
      this.dlg.noticeOptions = records
    },
    buildModalTitle (row) {
      if (!row) return '计划与过衡匹配'
      const t = row.trainArrivalTime || '—'
      const cnt = row.carriageCount != null ? row.carriageCount : '—'
      const tn = row.trainNumber ? ` · ${row.trainNumber}` : ''
      return `匹配计划 — 重车 ${t} · ${cnt} 节${tn}`
    },
    async openMatch (row) {
      this.dlg.visible = true
      this.dlg.listRow = row
      this.dlg.modalTitle = this.buildModalTitle(row)
      this.dlg.transportRecordId = row.id
      this.dlg.arrivalNoticeId = null
      this.dlg.planRows = []
      await this.loadNoticeOptions()
      await this.refreshWeighDetail()
    },
    extSerialKey (row) {
      if (row.carriageSerial != null) return row.carriageSerial
      if (row.carriageCount != null) return row.carriageCount
      return 0
    },
    async refreshWeighDetail () {
      if (!this.dlg.transportRecordId) return
      const res = await getDetail(this.dlg.transportRecordId)
      const dto = (res && res.data && res.data.data) || {}
      const list = dto.list || []
      this.dlg.weighRows = [...list].sort((a, b) => this.extSerialKey(a) - this.extSerialKey(b))
    },
    async onNoticeChange (id) {
      if (!id) {
        this.dlg.planRows = []
        return
      }
      const res = await getArrivalNoticeDetail(id)
      const dto = (res && res.data && res.data.data) || {}
      const list = dto.list || []
      this.dlg.planRows = list.map((r) => ({ ...r }))
    },
    async saveBind () {
      if (!this.dlg.transportRecordId || !this.dlg.arrivalNoticeId) {
        this.$message.warning('请选择到货通知')
        return
      }
      this.dlg.saving = true
      try {
        const weighCarriages = (this.dlg.weighRows || [])
          .filter((r) => r && r.id != null)
          .map((r) => ({
            id: r.id,
            carriageNumber: r.carriageNumber != null ? String(r.carriageNumber).trim() : ''
          }))
        const planCarriages = (this.dlg.planRows || [])
          .filter((r) => r && r.id != null)
          .map((r) => ({
            id: r.id,
            carriageNo: r.carriageNo != null ? String(r.carriageNo).trim() : ''
          }))
        await bindArrivalNotice({
          transportRecordId: this.dlg.transportRecordId,
          arrivalNoticeId: this.dlg.arrivalNoticeId,
          weighCarriages,
          planCarriages
        })
        this.$message.success('已保存匹配并绑定计划')
        this.dlg.visible = false
        this.onLoad(this.page, this.query)
      } catch (e) {
        /* axios 拦截器已提示错误 */
      } finally {
        this.dlg.saving = false
      }
    },
    onDlgClosed () {
      this.dlg.listRow = null
      this.dlg.modalTitle = '计划与过衡匹配'
      this.dlg.transportRecordId = null
      this.dlg.arrivalNoticeId = null
      this.dlg.noticeOptions = []
      this.dlg.weighRows = []
      this.dlg.planRows = []
    },
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `运输到达记录_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.match-dialog-body {
  font-size: 13px;
  color: #475569;
}
.field-block {
  margin-bottom: 14px;
}
.field-label {
  display: block;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 6px;
  font-weight: 600;
}
.plan-select-full {
  width: 100%;
  max-width: 100%;
}
.match-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  align-items: center;
  font-size: 12px;
  color: #475569;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
}
.match-legend strong {
  color: #1e40af;
}
.legend-actions {
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.dual-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}
@media (max-width: 1100px) {
  .dual-grid {
    grid-template-columns: 1fr;
  }
}
.dual-pane {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fafafa;
  max-height: 420px;
  display: flex;
  flex-direction: column;
}
.pane-head {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  padding: 10px 12px;
  margin: 0;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}
.pane-scroll {
  overflow: auto;
  flex: 1;
  min-height: 120px;
}
.pane-placeholder {
  padding: 24px;
  text-align: center;
  color: #b91c1c;
  font-size: 13px;
  background: #fff1f2;
}
.cell-input ::v-deep .el-input__inner {
  font-size: 12px;
}
.cell-input.is-warn ::v-deep .el-input__inner {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
  font-weight: 600;
}
.tag-mini {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 4px;
  background: #e2e8f0;
  color: #475569;
}
.dlg-hint {
  font-size: 12px;
  color: #64748b;
  margin-top: 12px;
  line-height: 1.55;
}
.dialog-footer-inner {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
::v-deep .transport-record-match-dialog .el-dialog__body {
  padding: 16px 20px 8px;
}
::v-deep .transport-record-match-dialog .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #e2e8f0;
}
::v-deep .dual-pane .row-ok td {
  background: #f7fee7 !important;
}
::v-deep .dual-pane .row-danger td {
  background: #fff1f2 !important;
}
.detail-dialog-body {
  min-height: 120px;
}
.detail-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  font-size: 13px;
  color: #475569;
  margin-bottom: 14px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.detail-summary b {
  color: #1e293b;
  font-weight: 600;
}
.detail-subtitle {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}
::v-deep .transport-record-detail-dialog .el-dialog__body {
  padding: 16px 20px 8px;
}
::v-deep .transport-record-detail-dialog .el-dialog__footer {
  padding: 10px 20px 14px;
  border-top: 1px solid #ebeef5;
}
</style>
